var REQUIRED_DISPLAYKEY = 'displaykey.Edge.Web.Api.Model.NotNull';

export default (function (currentViewModelNode, translator) {
    return {
        'valid': {
            'get': function get() {
                return !(currentViewModelNode.aspects.required && (currentViewModelNode.answer === undefined || currentViewModelNode.answer === null));
            }
        },
        'validationMessages': {
            'get': function get() {
                if (!currentViewModelNode.aspects.valid) {
                    return [translator(REQUIRED_DISPLAYKEY)];
                }
                return [];
            }
        },
        'validationMessage': {
            'get': function get() {
                if (!currentViewModelNode.aspects.valid) {
                    return translator(REQUIRED_DISPLAYKEY);
                }
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-questionsets-js/aspects/Validity.js
// module id = 904
// module chunks = 0